<!-- Adapted from swingmx/webclient src/components/PlaylistsList/PlaylistCard.vue,
     f0b87657c6450dc12d2dfd286b75f501410dcabd. MIT / Mungai Njoroge.
     p-card / image / overlay / p-name / p-count template and grid CSS retained.
     Existing app routes preserve the complete mixed-source playlist.
     Link interaction uses the SaltUI Item hover/press overlay without nesting a button. -->
<template>
  <router-link :to="playlist.route" class="p-card" :data-playlist-source="playlist.source">
    <div class="image"><PlaylistArtwork v-if="playlist.localId" :playlist-id="playlist.localId" alt="" loading="lazy" /><ArtworkImage v-else :src="artwork" :fallback="fallbackCover" :retry-key="playlist.coverRevision" alt="" loading="lazy" @source-error="repairCover(playlist, $event)" /></div>
    <div class="overlay">
      <div v-if="playlist.source" class="rhelp playlist"><span class="help">{{ playlist.source }}</span></div>
      <div class="p-name ellip" :title="playlist.name">{{ playlist.name }}</div>
      <div class="p-count">{{ playlist.trackCount }} 首歌曲</div>
    </div>
  </router-link>
</template>
<script>
import { runtime } from '../../bridge';
import { repairAccountPlaylistCover } from '../../accounts';
import ArtworkImage from '../../components/ArtworkImage.vue';
import PlaylistArtwork from '../../components/PlaylistArtwork.vue';
export default {
  name: 'SwingPlaylistCard',
  components: { ArtworkImage, PlaylistArtwork },
  props: { playlist: { type: Object, required: true } },
  computed: { artwork() { return this.playlist.coverUrl || runtime.cover(this.playlist.track); }, fallbackCover() { return runtime.cover(); } },
  methods: {
    repairCover(card, failure) { const identity = card.accountIdentity; if (identity) void repairAccountPlaylistCover(identity.platform, identity.accountId, identity.playlistId, failure); },
  },
};
</script>
<style scoped>
.p-card { position:relative; isolation:isolate; background:transparent; display:grid; grid-template-rows:1fr max-content; padding:8px; gap:8px; user-select:none; height:max-content; min-width:0; border-radius:6px; color:inherit; cursor:default; -webkit-tap-highlight-color:transparent; }
.p-card::after { content:''; position:absolute; inset:0; border-radius:inherit; pointer-events:none; background:transparent; }
.image { position:relative; border-radius:6px; overflow:hidden; }
.p-card:hover::after,.p-card:focus-visible::after { background:var(--salt-hover-overlay); }
.p-card:active::after { background:var(--salt-press-overlay); }
img { display:block; width:100%; aspect-ratio:1; object-fit:cover; }
.overlay { display:flex; flex-direction:column; justify-content:flex-end; min-width:0; }
.p-name { font-weight:500; font-size:14px; line-height:1.5; }
.ellip { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.p-count,.rhelp { font-size:12px; color:var(--salt-subtext,var(--color-secondary)); }
.p-count { margin-top:3px; }.rhelp { margin-bottom:3px; }
.p-card:focus-visible { outline:none; }
</style>
